import { Drawer, Hidden } from '@material-ui/core';
import clsx from 'clsx';
import React, { useImperativeHandle, useState } from 'react';
import FusePageSimpleSidebarContent from './FusePageSimpleSidebarContent';

const FusePageSimpleSidebar = (props, ref) => {
	const [isOpen, setIsOpen] = useState(false);
	const { classes, variant, position } = props;

	useImperativeHandle(ref, () => ({
		toggleSidebar: handleToggleDrawer,
	}));

	const handleToggleDrawer = () => {
		setIsOpen(!isOpen);
	};

	return variant === 'permanent' ? (
		<Hidden mdDown>
			<Drawer
				className={clsx(classes.sidebarWrapper, variant)}
				classes={{
					paper: clsx(classes.sidebar, variant, position === 'left' ? classes.leftSidebar : classes.rightSidebar),
				}}
				open={isOpen}
				variant="permanent"
			>
				<FusePageSimpleSidebarContent {...props} />
			</Drawer>
		</Hidden>
	) : null;
};

export default React.forwardRef(FusePageSimpleSidebar);
